// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"85d9b89b","513":"d503cd78","703":"08b628f0","787":"247051f6"}[chunkId] + ".chunk.js";
};